// Temporary buydown loan types. The first digit is the Year-1 rate reduction (in
// percent below the note rate), the next digits are the following years; a step
// runs until the note rate is reached, then the full note rate applies.
export const BUYDOWN_3_2_1 = "3-2-1";
export const BUYDOWN_2_1 = "2-1";
export const BUYDOWN_1_1 = "1-1";
export const BUYDOWN_1_0 = "1-0";

// Dropdown label map (Select is the placeholder default option).
export const BUYDOWN_TYPES = Object.freeze({
  [BUYDOWN_3_2_1]: "3-2-1",
  [BUYDOWN_2_1]: "2-1",
  [BUYDOWN_1_1]: "1-1",
  [BUYDOWN_1_0]: "1-0"
});

// Rate reduction (in %) applied each buydown year. Length = number of stepped
// years. 1-0 has a single stepped year (Year 1 only), then full note rate.
export const BUYDOWN_REDUCTIONS = Object.freeze({
  [BUYDOWN_3_2_1]: [3, 2, 1],
  [BUYDOWN_2_1]: [2, 1],
  [BUYDOWN_1_1]: [1, 1],
  [BUYDOWN_1_0]: [1]
});

// Who pays the buydown subsidy (credit source).
export const BUYDOWN_SELLER = "seller";
export const BUYDOWN_LENDER = "lender";
export const BUYDOWN_BUILDER = "builder";
export const BUYDOWN_PAID_BY = Object.freeze({
  [BUYDOWN_SELLER]: "Seller Credit",
  [BUYDOWN_LENDER]: "Lender Credit",
  [BUYDOWN_BUILDER]: "Builder Credit"
});

// How the Loan Estimate / Closing Disclosure discloses the product.
//  - Step Rate    -> "Rate Option", rate discloses as adjustable, AIR table
//  - Step Payment -> "Payment Option", rate fixed, only payment steps, AP table
export const STEP_RATE = "step_rate";
export const STEP_PAYMENT = "step_payment";
export const BUYDOWN_DISCLOSE = Object.freeze({
  [STEP_RATE]: "Step Rate",
  [STEP_PAYMENT]: "Step Payment"
});
